import React from "react";
import { ExternalLink } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { trackEvent } from "@/lib/analytics";

const q = (song) => encodeURIComponent(`${song.title} ${song.artist}`);

const SERVICES = [
  { id: "apple", label: "Apple Music", href: (s) => s.store_url || `https://music.apple.com/search?term=${q(s)}`, cls: "bg-[#fc3c44]/15 text-[#ff6b72] hover:bg-[#fc3c44]/25" },
  { id: "spotify", label: "Spotify", href: (s) => `https://open.spotify.com/search/${q(s)}`, cls: "bg-[#1DB954]/15 text-[#1ed760] hover:bg-[#1DB954]/25" },
  { id: "youtube", label: "YouTube", href: (s) => `https://www.youtube.com/results?search_query=${q(s)}`, cls: "bg-[#FF0000]/15 text-[#ff5c5c] hover:bg-[#FF0000]/25" },
];

/** "Listen to the full song" links: the bundled audio is a legal 30s preview, full tracks live on the streaming services. */
export default function ListenFull({ song, countryCode, compact = false }) {
  const { t } = useLang();
  if (!song) return null;
  const track = (id) => trackEvent("listen_full", { service: id, country_code: countryCode, title: song.title });
  return (
    <div className={compact ? "flex items-center gap-1.5 flex-wrap" : "space-y-1.5"} data-testid="listen-full">
      {!compact && (
        <div className="text-[10px] uppercase tracking-[0.15em] text-sand/60">
          {t("listen_full")} <span className="text-sand/40 normal-case tracking-normal">· {t("preview_note")}</span>
        </div>
      )}
      <div className="flex items-center gap-1.5 flex-wrap">
        {SERVICES.map(({ id, label, href, cls }) => (
          <a key={id} href={href(song)} target="_blank" rel="noopener noreferrer" onClick={() => track(id)}
            title={`${t("listen_full")} – ${label}`}
            className={`inline-flex items-center gap-1 rounded-full font-medium transition-colors ${cls} ${compact ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs"}`}
            data-testid={`listen-full-${id}`}>
            {label} <ExternalLink className={compact ? "w-2.5 h-2.5" : "w-3 h-3"} />
          </a>
        ))}
      </div>
    </div>
  );
}
